module.exports = __webpack_public_path__ + "static/media/crow_pick_roti_foot.d3d49bb3.gif";